export default function HeroSection() {
  return (
    <section className="relative w-full min-h-[620px] md:min-h-[700px] flex items-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20geometric%20fashion%20collage%20with%20overlapping%20soft%20pastel%20shapes%20in%20warm%20terracotta%20and%20sage%20green%20tones%2C%20delicate%20textile%20textures%20floating%20in%20airy%20composition%2C%20ethereal%20gradient%20background%20with%20subtle%20grain%20texture%2C%20modern%20editorial%20design%20aesthetic%2C%20dreamy%20atmosphere&width=1800&height=900&seq=hero-bg-acbuy-v2-2026&orientation=landscape"
          alt="ACBuySpreadsheet fashion collection background"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/35 via-black/20 to-black/40"></div>
      </div>

      <div className="relative z-10 w-full px-4 md:px-6 py-20 md:py-24">
        <div className="max-w-4xl mx-auto flex flex-col items-center text-center">
          <p className="text-white/80 text-xs md:text-sm font-label tracking-widest uppercase mb-5">
            Trusted Knowledge Base &amp; Guide Platform
          </p>
          <h1 className="font-heading text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight mb-6">
            ACBuySpreadsheet
            <br />
            <span className="font-light italic">Ultimate Guide 2026</span>
          </h1>
          <p className="text-white/80 text-sm md:text-base max-w-2xl mb-10 leading-relaxed">
            Learn, compare, and master acbuyspreadsheet tools with structured
            guides, real comparisons, and expert insights — all in one place.
          </p>

          <div className="flex flex-col sm:flex-row items-center gap-4 mb-8">
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full bg-primary-500 text-background-50 font-label text-sm md:text-base font-semibold hover:bg-primary-600 transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              ACBuy Spreadsheet
            </a>
            <a
              href="https://kaspreadsheet.com/"
              target="_blank"
              rel="noopener nofollow"
              className="px-8 py-3.5 rounded-full border border-white/50 text-white font-label text-sm md:text-base font-semibold hover:bg-white/10 hover:border-white transition-all duration-300 whitespace-nowrap cursor-pointer"
            >
              Buy It Now
            </a>
          </div>

          <p className="text-white/50 text-xs md:text-sm">
            Trusted by users exploring advanced spreadsheet systems worldwide
          </p>
        </div>
      </div>

      <div className="absolute bottom-6 md:bottom-10 left-0 right-0 z-10">
        <p className="font-heading text-white/15 text-4xl md:text-7xl lg:text-9xl font-black text-center tracking-tighter select-none">
          SMARTER SPREADSHEET SYSTEM
        </p>
      </div>
    </section>
  );
}